<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>{{ $t('enum.latestDrafts') }}</h2>
    </div>
    <div class="body_box" v-if="List.length > 0">
      <div class="soild_box" v-for="(obj, k) in List" :key="k">
        <el-image class="like_img" :src="obj['NewCommunityImages'] && obj['NewCommunityImages'].length > 0 && obj['NewCommunityImages'][0]['ImageUrl'] ? obj['NewCommunityImages'][0]['ImageUrl'] + $store.state.thumbnail : '/static/images/noimg.svg'" fit="contain"></el-image>
        <div class="soild_txt">
          <p class="line_txt3">
            {{ $store.getters.setTitle(obj['Title']) }}
          </p>
          <div class="soild_btn">
            <!-- <router-link :to="`/commodity/New?did=${obj['_id']}&clone=new`"><span>Sell Similar</span></router-link> -->
            <router-link :to="`/commodity/New?did=${obj['_id']}`"><span>{{ $t('button.resume') }}</span></router-link>
            <span @click="WatchDelete(obj._id)">{{ $t('button.delete') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-data">{{ loading ? $t('enum.loading') + "..." : $t('enum.noData') }}</div>
    <!-- <div>Total：{{Count}}</div> -->
  </div>
</template>

<script>

export default {
  name: "",
  data() {
    return {
      UserInfo: this.$store.state.UserInfo,
      loading: true, //page loading
      List: [],
      Count: 0,
      PageIndex: 1,
      PageSize: 100,
    };
  },
  created: function () {
    var that = this;
  },
  mounted: function () {
    var that = this;
    that.getData('GetCommodityByPage', `?pageSize=${that.PageSize}&pageIndex=${that.PageIndex}`);
  },
  computed: {},
  methods: {
    getData(api, data = '') {
      var that = this;
      var fun = "";
      switch (api) {
        case "GetCommodityByPage": //获取草稿列表
          that.loading = true;
          fun = function (res) {
            that.loading = false;
            if (res.result) {
              var _data = res.data
              that.List = _data;
              that.Count = res.count;
            }
          };
          // this.axios.get(that.$interface[api], data).then((response) => {
          //   console.log(response.data)
          // }).catch((err) => {
          //     console.log(err);
          //   });
          that.$get(api, data)
            .then((res) => {
              console.log("axios-res:", api, res);
              fun(res);
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case "DeleteDraftCommodity": //删除当前草稿
          fun = function (res) {
            if (res.result) {
              that.$message({
                type: 'success',
                message: 'Deleted Successfully'
              });
              that.getData('GetCommodityByPage', `?pageSize=${that.PageSize}&pageIndex=${that.PageIndex}`);
            }
          };
          that.$post(api, data)
            .then((res) => {
              console.log("axios-res:", api, res);
              fun(res);
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        default:
          break;
      }
    },
    //删除的弹框
    WatchDelete(id) {
      var that = this;
      let title = "Delete";
      let msg =
        '<div class="p_txt">This will permanently delete the file.<span style="text-align: center;display: block;">Continue?</span></div>';
      this.$confirm(msg, title, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          console.log(id);
          const data = { id: id, memberId: that.UserInfo.Id, operator_id: that.UserInfo.MappingUserId, token: that.$store.state.ChToken }
          that.getData('DeleteDraftCommodity', data)
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        })
        .catch(() => {

        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.soild_box {
  width: 49%;
  padding: 12px;
  border: 1px solid #c8c8c8;
  border-radius: 10px;
  display: flex;
  margin-bottom: 20px;
}

.like_img {}

.soild_txt {
  flex: 1;
  margin-left: 12px;
  position: relative;
}

.soild_txt p {
  width: 90%;
  line-height: 1.5;
}

.soild_btn {
  position: absolute;
  bottom: 0;
  right: 0;
}

.soild_btn span {
  color: #5f6dae;
  margin-left: 16px;
  cursor: pointer;
}</style>



// WEBPACK FOOTER //
// src/pages/commodity/draft.vue